import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Price(props) {
  const {
    isDealerConfigurator,
    lang,
    order,
    strings,
    usePrice,
    useSecurityDeposit
  } = useContext(ConfiguratorContext)

  if (isDealerConfigurator) {
    return null
  }

  const MaybeBold = props.bold ? 'strong' : React.Fragment
  const type = props.type ?? 'price'
  const price = type === 'security-deposit' || type === 'global-security-deposit'
    ? useSecurityDeposit(type === 'global-security-deposit')
    : usePrice()
  const priceFormatsStrings = strings.price?.formats ?? {}

  const theprice = props.price !== null ? props.price : price
  const format = props.format !== null ? props.format : order.paymentType

  if (theprice <= 0 && props.hideempty === true) return null

  return (
    <div className={props.classname}>
      <MaybeBold>{new Intl.NumberFormat(lang).format(theprice)}</MaybeBold>{' '}
      {format === 'leasing' ? priceFormatsStrings.leasing : priceFormatsStrings.cash}
    </div>
  )
}

Price.defaultProps = {
  price: null,
  format: null,
  hideempty: false,
  classname: 'price'
}
